import { useState } from "react";
import { connect } from "react-redux";
import { formData } from "../../../../utils";
import { setUser } from "../../../../store/action/auth";
import AuthService from "../../../../services/auth/Auth";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import { Slide } from "../../../../components/dialog";
import RadioGroup from "../../../../components/radio/RadioGroup";
import { Warning } from "../../../../components/button";
import { Div, Col, Container, Row, Header, HeaderTitle } from "./style";

const ChangeSex = (props) => {
  const { user, refrence, theme, setUser } = props;

  const [isLoadingSendData, setIsLoadingSetData] = useState(false);
  const [data, setData] = useState({
    gender: {
      label: user?.data?.sex_text,
      value: user?.data?.sex,
    },
  });

  const handleSubmit = () => {
    if (isLoadingSendData === false) {
      setIsLoadingSetData(true);

      HttpService(user?.token)
        .post(
          "user/update",
          formData({
            sex_text: data.gender?.label,
            sex: data.gender?.value,
          })
        )
        .then((response) => {
          refrence.current.changeStatus();

          Http(response?.status, response?.data?.message, props);

          var dataS = {
            sex: data.gender?.value,
            sex_text: data.gender?.value === 1 ? "مرد" : "زن",
          };

          AuthService.chnage(user, dataS, setUser);
        })
        .catch((error) => {
          Http(error?.response?.status, error?.response?.data?.message, props);
        })
        .finally(() => {
          setIsLoadingSetData(false);
        });
    }
  };

  const onChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  return (
    <>
      <Slide fullWidth={true} ref={refrence}>
        <Row className="row no-gutters">
          <Col className="col-12 p-2">
            <Container className="p-3 text-right">
              <Header theme={theme}>
                <HeaderTitle theme={theme} className="d-block mb-3">
                  ویرایش جنسیت
                </HeaderTitle>
              </Header>
              <Div className="mt-2">
                <RadioGroup
                  name="gender"
                  label="جنسیت"
                  value={data.gender?.value}
                  items={[
                    {
                      label: "مرد",
                      value: 1,
                    },
                    {
                      label: "زن",
                      value: 2,
                    },
                  ]}
                  onChange={onChange}
                />
              </Div>
              <Div className="mt-2">
                <Warning
                  className="d-block"
                  title="ویرایش"
                  onClick={handleSubmit}
                  isLoading={isLoadingSendData}
                  sizeSpinner={20}
                />
              </Div>
            </Container>
          </Col>
        </Row>
      </Slide>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(ChangeSex);
